import React, { Component } from 'react';
import cn from 'classnames';

import BlockGallery from '../../StaticRenderer/BlockGallery';

export default class Gallery extends Component {
  render() {
    const {
      block,
      contentState
    } = this.props;

    const content = contentState.getEntity(block.getEntityAt(0)).getData();

    return (
      <div className="draft-js-block draft-js-block-company">
        <div className="draft-js-container">
          <div className={cn({ 'draft-js-content': !content.isFullWidth })}>
            <BlockGallery content={content} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/DraftEditor/GalleryPlugin/Gallery.js